import { Component, OnInit } from '@angular/core';
import { DirtyComponent } from '../../../core/components/errors/dirty-check.component';
import { BehaviourService } from '../../../shared/services/behaviour.service';
import { ConfigService } from '../../../shared/services/config.service';

@Component({
  selector: 'app-bbx-mapping',
  templateUrl: './bbx-mapping.component.html',
  styleUrls: ['./bbx-mapping.component.css'],
})

//TODO : Onchange tab check dirty for save event
export class BbxMappingComponent implements OnInit, DirtyComponent {
  isDirty: boolean = false;
  isCustomInvoice: boolean = false;

  constructor(private behaviourService: BehaviourService, private configService: ConfigService) {}

  canDeactivate() {
    return this.isDirty;
  }

  isDirtyCheckEvent(event) {
    this.isDirty = event;
  }

  getUpdatedData() {
    this.configService.fetchConfig('default_invoice_export').then(response => {
      sessionStorage.setItem('isCustomInvoice', response?.data[0]);
      this.isCustomInvoice = sessionStorage.getItem('isCustomInvoice') === 'Custom';
    });

    this.behaviourService.currentMessage.subscribe(() => {
      this.isCustomInvoice = sessionStorage.getItem('isCustomInvoice') === 'Custom';
    });
  }

  ngOnInit(): void {
    this.getUpdatedData();
  }
}
